export default {
  LIST_FETCHED: 'SUBSCRIPTION_PLANS_FETCHED',
  LIST_LOAD: 'SUBSCRIPTION_PLANS_LOAD',
  ITEM_DETAIL: 'SUBSCRIPTION_PLANS_DETAIL',
  BUTTON_LOAD: 'SUBSCRIPTION_PLANS_BUTTON_LOAD',
};
